import { ca } from '@cian/analytics';

import { getAllProducs } from '../../../utils/trackings';
import { IFavoriteEntity } from '../../../types/results';

export function trackShareWhatsAppClick(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'Click',
    label: 'ShareWhatsApp',
    products,
  });
}
